"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const ThemeContext_1 = require("../../../interface/ThemeContext");
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => ({}));
exports.default = connector(({}) => {
    const themeContext = (0, ThemeContext_1.useThemeContext)();
    const currentColor = themeContext.colors.white;
    const sections = [
        {
            title: "Information We Collect",
            description: (react_1.default.createElement(react_1.default.Fragment, null, "When you use Swivvl, we collect personal information related to you in the following categories:")),
            list: [
                "Contact Information: Names and email addresses.",
                "Payment Information: For processing transactions.",
                "Usage Data: Including historical data from integrated TMS systems, customer information, and previous shipment data.",
                "Cookies and Tracking Technologies: To analyze how our services are accessed and used.",
            ],
        },
        {
            title: "How We Use This Information",
            description: react_1.default.createElement(react_1.default.Fragment, null, "Your information is used to:"),
            list: [
                "Provide and improve our services.",
                "Conduct analytics and marketing efforts.",
                "Support customer service inquiries.",
            ],
        },
        {
            title: "Sharing Your Information",
            description: (react_1.default.createElement(react_1.default.Fragment, null, "Currently, Swivvl does not share your personal data with third parties. Should this change in the future, we will update our policy accordingly and implement measures to ensure the security of your data.")),
        },
        {
            title: "Your Rights",
            description: (react_1.default.createElement(react_1.default.Fragment, null, "You have the right to access, update, or delete your personal information. Requests can be made by contacting support@swivvl.com.")),
        },
        {
            title: "Data Security",
            description: (react_1.default.createElement(react_1.default.Fragment, null, "We take the security of your data seriously and implement appropriate measures to protect against unauthorized access or data breaches.")),
        },
        {
            title: "Changes to This Policy",
            description: (react_1.default.createElement(react_1.default.Fragment, null, "We may update this policy to reflect changes to our information practices. If we make any material changes, we will notify you by updating the date at the top of this policy.")),
        },
        {
            title: "Contacting Us",
            description: (react_1.default.createElement(react_1.default.Fragment, null,
                "If you have any questions about this Privacy Policy, please contact us at ",
                react_1.default.createElement("a", { href: "mailto:help@swivvl.com" }, "help@swivvl.com"),
                ".")),
        },
    ];
    return (react_1.default.createElement("div", { className: "policy-outer-container", id: "policy-container" },
        react_1.default.createElement("div", { className: "policy-inner-container container px-6" },
            react_1.default.createElement("h3", { className: "policy-header" }, "Privacy Policy of Swivvl LLC"),
            react_1.default.createElement("p", { className: "policy-header-description" }, "At Swivvl, we are committed to maintaining the trust and confidence of our users. In this Privacy Policy, we've provided detailed information on when and why we collect personal information, how we use it, the limited conditions under which we may disclose it to others, and how we keep it secure."),
            sections.map((section) => (react_1.default.createElement("section", { className: "policy-section-container" },
                react_1.default.createElement("h4", null, section.title),
                react_1.default.createElement("p", null, section.description),
                section.list &&
                    section.list.map((item) => (react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", null, item))))))))));
});
